export const getScrollbarWidth = () => {
    const { body } = document;
    const scrollDiv = document.createElement('div');

    // Append element with defined styling
    scrollDiv.setAttribute('style', 'width: 1337px; height: 1337px; position: absolute; left: -9999px; overflow: scroll;');
    body.appendChild(scrollDiv);

    // Collect width & height of scrollbar
    const scrollbarWidth = scrollDiv[`offsetWidth`] - scrollDiv[`clientWidth`];

    // Remove element
    body.removeChild(scrollDiv);

    return scrollbarWidth;
};
